import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllAmountUnits, getSymbolGroup, getAllSymbolParameters } from "../../api/request/dashboard/dashboard";

export const fetchSymbolGroup = createAsyncThunk('symbolGroup/get', async () => {
    try {
        const { data } = await getSymbolGroup();
        return data;
    } catch (err) {
        return [];
    }
})

export const fetchAmountUnit = createAsyncThunk('amountUnit/get', async () => {
    try {
        const { data } = await getAllAmountUnits();
        return data;
    } catch (err) {
        return [];
    }
})

export const fetchAllSymbolParams = createAsyncThunk('allSymbolParameter/get', async (_, { getState }) => {
    try {
        const clientId = getState().user?.userDetail?.id
        const { data } = await getAllSymbolParameters(clientId);
        const objData = {}
        data?.map(item => {
            objData[item.symbolId] = { ...objData[item.symbolId], ...item, }
        })
        // console.log(objData)
        return objData;
    } catch (err) {
        return [];
    }
})